import { render, staticRenderFns } from "./FullScreenImageCarousel.vue?vue&type=template&id=55d6b667&scoped=true"
import script from "./FullScreenImageCarousel.vue?vue&type=script&lang=js"
export * from "./FullScreenImageCarousel.vue?vue&type=script&lang=js"
import style0 from "./FullScreenImageCarousel.vue?vue&type=style&index=0&id=55d6b667&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d6b667",
  null
  
)

export default component.exports